const transmissionAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      /* GSAP ANIMATIONS */

      //Smooth content

      ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 1,
        effects: true,
      });


      //Arrow button

      document.querySelector('button.arrow-btn').addEventListener('click', () => {
        gsap.to(window, { duration: 2, scrollTo: { y: ".intro", offsetY: 75 } });
      })

      //H1

const h1 = document.querySelector("h1.title1");
if (h1) {
  const h1Split = new SplitText(h1, { type: "lines,words,chars", linesClass: "split-line", charsClass: "js-char" });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: h1,
      start: "top 80%",
      toggleActions: "play reverse play reverse",
      markers: false,
    },
  });

  // 1. Animation d'apparition de chaque ligne (comme le span)
  tl.from(h1Split.lines, {
    yPercent: (i) => (i % 2 === 0 ? 100 : -100),
    opacity: 0,
    duration: 0.5,
    stagger: 0.2,
    ease: "power3.inOut",
  });

  // 2. Animation des caractères à l'intérieur de chaque ligne
  h1Split.lines.forEach((line, i) => {
    tl.from(
      line.querySelectorAll(".js-char"),
      {
        opacity: 0,
        yPercent: 20,
        duration: 0.8,
        stagger: 0.04,
        ease: "power3.inOut",
      },
      "-=0.7" // chevauche avec la fin de l'anim de la ligne
    );
  });
}



      //H2

      const h2Elements = document.querySelectorAll("h2");
      h2Elements.forEach((h2) => {
        const h2Split = new SplitText(h2, {
          type: "lines",
          linesClass: "split-child",
        });
        gsap.from(h2Split.lines, {
          duration: 2,
          yPercent: 100,
          ease: "power4",
          stagger: 0.1,
          scrollTrigger: {
            trigger: h2,
            start: "top 90%",
            //end: "+=100%",
            toggleActions: "play reverse play reverse",
          },
        });
      });

      //Intro section

      gsap.from(".intro .img-side", {
        scrollTrigger: {
          trigger: ".intro",
          start: "top 80%",

          end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: -200,
        opacity: 0,
      });

      gsap.from(".intro .txt-side p", {
        scrollTrigger: {
          trigger: ".intro",
          start: "top 80%",

          //end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: 200,
        opacity: 0,
      });

      //missions section

      gsap.from(".mission", {
        y: 100,
        opacity: 0,
        stagger: 0.1,
        scrollTrigger: {
          trigger: ".missions",
          start: "top 80%",
          toggleActions: "play reverse play reverse",
          markers: false,
        },
      });

      //Support section
      gsap.from(".support .img-side", {
        scrollTrigger: {
          trigger: ".support",
          start: "top 80%",

          end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: 200,
        opacity: 0,
      });
      gsap.from(".support .txt-side p", {
        scrollTrigger: {
          trigger: ".support",
          start: "top 80%",

          //end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: -200,
        opacity: 0,
      });

      //Keywords rail
      gsap.to(".rail", {
        xPercent: -50,
        ease: "none",
        duration: 30,
        repeat: -1,
      });


      //Consolidation section
      gsap.from(".consolidation-item", {
        y: 100,
        opacity: 0,
        stagger: 0.1,
        scrollTrigger: {
          trigger: ".consolidation",
          start: "top 80%",
          toggleActions: "play reverse play reverse",
          markers: false,
        },
      });


      

    
    });
  },
};

export default transmissionAnim;
